
<template>
    <div>
        <div id="qr-code-reader"></div>
    </div>
</template>
<script>
//html5-qrcode/dist/html5-qrcode.min.jshttps://raw.githubusercontent.com/mebjas/html5-qrcode/master/minified/html5-qrcode.min.js
//import 'html5-qrcode/dist/html5-qrcode.min.js'
import {Html5Qrcode} from "html5-qrcode";
var QRCODEREAD

export default {

  props: {
    qrbox: {
      default: 250
    },
    fps: {
      type: Number,
      default: 10
    },
  },
  beforeDestroy() {
    window.EventBus.$off('update:stopQRCODE', this.stop)
    window.EventBus.$off('update:startQRCODE', this.start)
  },
  created(){
  },
  mounted () {
       this.start();
       //console.log('mounted qrcode')
       window.EventBus.$on('update:stopQRCODE', this.stop)
       window.EventBus.$on('update:startQRCODE', this.start)
  },
  methods: {
    async checkCameraAccess() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            // Se chegou aqui, permissão foi concedida
            //console.log("✅ Câmara disponível");
            // Para parar o stream depois do teste:
            stream.getTracks().forEach(track => track.stop());
            return true;
        } catch (err) {
             //console.warn("❌ Acesso à câmara bloqueado:", err);
            return false;
        }
    },
    start(){
     // console.log('QRCODEREAD')
        /*const temAcesso = this.checkCameraAccess();
        if (!temAcesso) {
            alert("Câmara bloqueada ou sem permissão. Por favor, verifique as definições do Browser/Safari.");
        }else{*/
            const formatsToSupport = [
                Html5QrcodeSupportedFormats.CODE_39,
                Html5QrcodeSupportedFormats.CODE_93,
                Html5QrcodeSupportedFormats.CODE_128,
                Html5QrcodeSupportedFormats.ITF,
                Html5QrcodeSupportedFormats.EAN_13,
                Html5QrcodeSupportedFormats.EAN_8,
                Html5QrcodeSupportedFormats.PDF_417,
                Html5QrcodeSupportedFormats.RSS_14,
                Html5QrcodeSupportedFormats.UPC_A,
                Html5QrcodeSupportedFormats.UPC_E,
                Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
            ];
            const config = {
                fps: this.fps,
                qrbox: this.qrbox,
                //formatsToSupport: formatsToSupport
            };

            /*//const devices = await Html5Qrcode.getCameras();
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(device => device.kind === 'videoinput');
            //console.log("Câmeras disponíveis:", videoDevices,videoDevices[0].deviceId);
            // Exemplo: selecionar a segunda câmera (índice 1)
            //const desiredDeviceId = _.size(videoDevices)==4?videoDevices[3].deviceId:_.size(videoDevices)==3?videoDevices[2].deviceId:_.size(videoDevices)==2?videoDevices[1].deviceId:videoDevices[0].deviceId;
            //console.log('devices',devices);
            if (!videoDevices || videoDevices.length === 0) {
                alert("Nenhuma câmara encontrada. Por favor, verifique as permissões no Browser/Safari");
                return;
            }*/
            /*let camera={}
            if(_.size(devices)<=3){
                camera = devices[0].id;
            }else{
                camera={ facingMode: "environment" }
                //const cameraId = devices[0].id; // usa a primeira câmara disponível
            }
            //const cameraId = devices[0].id; // usa a primeira câmara disponível
            console.log('devices',devices,camera,desiredDeviceId);*/
            //this.stop();
            QRCODEREAD = new Html5Qrcode(
            "qr-code-reader",{formatsToSupport: formatsToSupport});
            QRCODEREAD.start({ facingMode: "environment" }, config,this.onScanSuccess,
                (errorMessage) => {
                // parse error, ignore it.
                //console.log('ERROR',errorMessage);
                })
            .catch((err) => {
                // Start failed, handle it.
                alert(this.$t('toasts.cameraError'));
                console.log('Start failed',err);
            });
        //}

                      //console.log(' QRCODEREAD SSSTART',_.cloneDeep(QRCODEREAD));
    },
    stop(){
      //console.log('QRCODEREAD',QRCODEREAD)
      if(QRCODEREAD){
        if(QRCODEREAD.isScanning){
          QRCODEREAD.stop().then((ignore) => {
          // QR Code scanning is stopped.
          }).catch((err) => {
            // Stop failed, handle it.
          });
        }

      }

    },
    onScanSuccess (decodedText, decodedResult) {
      //console.log('onScanSuccess qr-code',decodedText, decodedResult)
      this.$emit('result', decodedText, decodedResult);
    }
  }
}
</script>

